// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"styles-module--headerContainer--1SIbg","header":"styles-module--header--cM8x-","headerCategoryActive":"styles-module--headerCategoryActive--1PQuf"};